<template>
  <div v-if="showlist">
    <transition name="modal">
      <div class="modal-mask upl-holdNEW wdth-700" style="overflow-y: auto; display: block;">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header">
              <h4 class="modal-title mt-2">Uploaded Documents</h4>
              <button type="button" class="close up-close" @click="$emit('close')">×</button>
            </div>

            <div class="modal-body" v-if="filelist && filelist.length > 0">
              <div class="fileulpd-sec">
                <div class="row">
                  <div class="col-md-6">
                    <p class="sub-head-uplmodal">
                      {{ filelist.length }} {{ filelist.length > 1 ? 'Files uploaded' : 'File uploaded' }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="filelisthold">
                <div class="row upl-hover" v-for="item in filelist" :key="item.document_id">
                  <div class="col-9">
                    <div class="test-reports-right">
                      <button class="btn btn-downloadico"></button>
                      <div class="filename pl-3">
                        <div class="row">
                          <div class="col-md-6">
                            <a href="javascript:void(0)" @click="viewFile(item)" data-toggle="tooltip" :title="item.file_name" class="down-link tkout-wrap">
                               <span class="down-link tkout-wrap">
                              {{ textEllipsis(item.file_name, 30) }}
                            </span>
                            </a>
                          </div>
                          <div class="col-md-6 px-0">
                            <div class="timehold text-right" v-if="item.created_date">
                              {{ formatDateTime(item.created_date) }}
                            </div>
                          </div>
                        </div>
                        <!-- Document type badge -->
                        <small class="text-muted">
                          <span class="badge badge-secondary">{{ formatDocType(item.document_type) }}</span>
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="col-3 pl-4 pr-0">
                    <div class="modal-upl-hold">
                      <ul>
                        <li class="pt-1">
                          <!--  View button -->
                          <a 
                            href="javascript:void(0)" 
                            class="action-view" 
                            @click="viewFile(item)"
                            data-toggle="tooltip" 
                            title="View"
                          ></a>
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="modal-body" v-if="!(filelist && filelist.length)" style="text-align:center;">
              No documents uploaded yet.
            </div>

          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
import Auth from "@/common/mixins";

export default {
  name: "VIPDocumentsPopup",
  props: {
    showlist:  { type: Boolean, default: false },
    isGuest:  { type: Boolean, default: true },
    filelist:  { type: Array,   default: () => [] },
    allocationId: { type: String, default: "" }
  },
  data() {
    return {
      isLoading: false,
      loggedin_user_unique_id:"",
      role_unique_id:""
    };
  },
  created() {
    if(Auth.checkAuthentication()){
      if(localStorage.loggedInUserInfo)
      {
        const loggedinuser= localStorage.loggedInUserInfo;
        this.loggedin_user_unique_id = loggedinuser.unique_id;
        this.role_unique_id = loggedinuser.role && loggedinuser.role.unique_id ? loggedinuser.role.unique_id : ""; 
      }
    }
  },
  computed: {
    is24timeFormat() {
      var businessetup = JSON.parse(localStorage.tenantbusinesssetup);
      if (businessetup && businessetup.is24timeFormat) {
        return true;
      }
      return false;
    },
  },
   updated() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
      $('[data-toggle="tooltip"]').tooltip({
        trigger: "hover",
        container: "body",
        boundary: "window",
      });
    });
  },
  methods: {
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "";

      const [datePart, timePart] = dateTimeStr.split(" ");
      if (!datePart || !timePart) return dateTimeStr;

      let day, month, year;

      if (datePart.includes("-")) {
        [day, month, year] = datePart.split("-");
      } else if (datePart.includes("/")) {
        const parts = datePart.split("/");
        month = parts[0];
        day = parts[1];
        year = parts[2];
      } else {
        return dateTimeStr;
      }

      let [hours, minutes] = timePart.split(":").map(Number);

      // 🔥 ADD IST OFFSET (+5:30)
      minutes += 30;
      hours += 5;

      if (minutes >= 60) {
        minutes -= 60;
        hours += 1;
      }

      if (hours >= 24) {
        hours -= 24;
      }

      // 👉 24-hour
      if (this.is24timeFormat) {
        return `${day}-${month}-${year} ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      }

      // 👉 12-hour
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      return `${day}-${month}-${year} ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${ampm}`;
    },
    async viewFile(item) {
      try {
        this.isLoading = true;
        const Url = this.isGuest ? '/GuestBedManagement/document-url/' :'/Patient-bed-management/document-url/';
        const response = await Axios({
          method: "get",
          url: rest_service.baseURL + Url + item.document_id,
          headers: {
            Authorization: localStorage.accesstoken,
            x_tenant_id:   localStorage.tenantid,
            role_unique_id: this.role_unique_id,
            route_entity_name: this.isGuest ?'/GuestBedManagement':'/Patient-bed-management',
            loggedin_user_unique_id: this.loggedin_user_unique_id,
          }
        });

        if (response && response.data) {
          const url = response.data.result.url;
          // PDF opens in new tab, images open in modal
          if (/\.(pdf)$/i.test(item.file_name)) {
            window.open(url, "_blank", "channelmode=1");
          } else {
            window.open(url, "_blank");
          }
        }
      } catch (error) {
        console.error("Failed to get document URL:", error);
      } finally {
        this.isLoading = false;
      }
    },

    formatDocType(type) {
      const map = {
        agreement:          "Agreement",
        idproof:            "ID Proof",
        attendant_idproof:  "Attendant ID Proof"
      };
      return map[type] || type;
    },

    textEllipsis(text, maxLength) {
      if (!text) return "";
      if (text.length <= maxLength) return text;
      const ext = text.lastIndexOf(".");
      const extension = ext !== -1 ? text.slice(ext) : "";
      return text.slice(0, maxLength - 3) + "..." + extension;
    }
  }
};
</script>
<style>
.modal-mask.upl-holdNEW.wdth-700 .modal-container {
  width: 700px;
}
.modal-mask.upl-holdNEW .modal-header {
    padding: 0;
    border: 0;
}
.modal-mask.upl-holdNEW h4.modal-title {
    text-align: center;
    width: 100%;
}

.modal-mask:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-wrapper {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  width: 100%;
}
.filelisthold {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
}

.reportlist-cred {
  text-align: left;
}
.row.upl-hover {
    margin-bottom: 0;
    padding: 10px 0 10px 10px;
}
.row.upl-hover:hover {
  background: #f8f9fa;
}
.fileulpd-sec {
  width: 100%;
  margin: 0 auto;
  display: block;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 10px;
}
.fileulpd-sec p.sub-head-uplmodal {
  border-bottom: 0px solid transparent;
  margin-bottom: 0;
}
p.p-blue1.sub-head-uplmodal {
  color: #0157e0;
}
.btn.btn-downloadico, .btn.btn-downloadico:active, .btn.btn-downloadico:focus {
    background: url(../../static/images/dashboard-newicons.png) 1px -741px no-repeat!important;
    width: 35px;
    height: 40px;
    float: left;
    display: block;
    outline: 0;
    -webkit-box-shadow: 0 0 0 .2rem rgba(0,123,255,0)!important;
    box-shadow: 0 0 0 .2rem rgba(0,123,255,0)!important;
    cursor: pointer;
    background-color: #f3f7fa!important;
}
button.fc-prev-button.fc-button.fc-state-default.fc-corner-left.invest-pre-BTN {
  background: #c9cdd4;
  color: #55627b;
  border: 0px transparent;
  padding: 5px 4px;
  height: 26px;
  width: 26px;
  text-shadow: none !important;
  box-shadow: none !important;
  cursor: pointer;
}
button.fc-next-button.fc-button.fc-state-default.fc-corner-right.invest-nxt-BTN {
  background: #c9cdd4;
  color: #55627b;
  border: 0px transparent;
  padding: 5px 4px;
  height: 26px;
  width: 26px;
  text-shadow: none !important;
  box-shadow: none !important;
  cursor: pointer;
}
button.fc-prev-button.fc-button.fc-state-default.fc-corner-left.invest-pre-BTN:hover,
button.fc-next-button.fc-button.fc-state-default.fc-corner-right.invest-nxt-BTN:hover {
  background: #55627b;
  color: #ffffff;
}
.filename {
    float: left;
    width: calc(100% - 35px);
}

.filelisthold .test-reports-right .filename {
    margin-top: 0px;
}
</style>
